import $ from 'jquery'

$(document).on('turbolinks:load', function (e) {
  const toggleButton = $('#customTimeframeToggle')

  if (toggleButton.length === 0) return

  toggleButton.on('click', function (e) {
    e.preventDefault()
    const formGroup = $(this).parents('.form-group')
    const customControls = formGroup.find('.custom-timeframe-option')

    if (customControls.is(':visible')) {
      // Hide the custom options
      customControls.hide()
      $(this).text('Show more options')
    } else {
      // Show the custom options
      customControls.show()
      $(this).text('Show less')
    }
  })
})
